import React from 'react';

export default function PauseIcon({
  width = 32,
  height = 32,
  className,
  style,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      <g clipPath="url(#clip0_10068_12104)">
        <path
          d="M15.9995 32C7.1778 32 0 24.8222 0 15.9995C0 7.17685 7.1778 0 15.9995 0C24.8212 0 31.999 7.1778 31.999 15.9995C31.999 24.8212 24.8212 31.999 15.9995 31.999V32ZM15.9995 2.10269C8.33715 2.10269 2.10268 8.33715 2.10268 15.9995C2.10268 23.6619 8.33715 29.8964 15.9995 29.8964C23.6619 29.8964 29.8964 23.6619 29.8964 15.9995C29.8964 8.33715 23.6629 2.10269 15.9995 2.10269Z"
          fill="currentColor"
        />
        <path
          d="M13.0513 21.9184C12.4702 21.9184 12 21.4482 12 20.8671V11.0513C12 10.4702 12.4702 10 13.0513 10C13.6324 10 14.1027 10.4702 14.1027 11.0513V20.8671C14.1027 21.4482 13.6324 21.9184 13.0513 21.9184Z"
          fill="currentColor"
        />
        <path
          d="M19.565 21.9184C18.9839 21.9184 18.5137 21.4482 18.5137 20.8671V11.0513C18.5137 10.4702 18.9839 10 19.565 10C20.1461 10 20.6164 10.4702 20.6164 11.0513V20.8671C20.6164 21.4482 20.1461 21.9184 19.565 21.9184Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10068_12104">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
